<script setup>
import { computed, ref } from "vue";
import Member from "@/pages/company/members/components/member/member.vue";
import { MemberDeleteModal } from "@/pages/company/members/components/member-delete-modal";

const props = defineProps({
  members: {
    type: Array,
    required: true
  },
  options: {
    type: Object,
    required: true
  },
  user: {
    type: Object,
    required: true
  },
  role: {
    type: String,
    required: true
  }
});

const emits = defineEmits(['update', 'delete']);
const selected = ref(null);
const isDeleteModalOpen = ref(false);

const isRoleCompanyOwner = computed(() => {
  return props.role === 'company_owner';
});

const isRoleCommunityLead = computed(() => {
  return props.role === 'community_lead';
});

const isRoleHrManagement = computed(() => {
  return props.role === 'hr_management';
});

function handleUpdateButtonClick(member) {
  emits('update', member);
}

function handleRemoveButtonClick(member) {
  selected.value = JSON.parse(JSON.stringify(member));
  isDeleteModalOpen.value = true;
}

function handleCancelButtonClick() {
  selected.value = null;
  isDeleteModalOpen.value = false;
}

function handleContinueButtonClick(member) {
  emits('delete', member)
  isDeleteModalOpen.value = false;
}

</script>

<template>
  <div class="overflow-x-auto rounded-lg bg-white shadow-redesign mt-6">
    <table class="w-max min-w-full overflow-x-hidden">
      <thead class="border-b">
      <tr>
        <th class="px-8 py-4 font-medium leading-normal text-zinc-600">
          {{ __('Name') }}
        </th>
        <th
            v-if="isRoleCompanyOwner || isRoleHrManagement"
            class="px-8 py-4 font-medium leading-normal text-zinc-600"
        >
          {{ __('Status') }}
        </th>
        <th class="px-8 py-4 font-medium leading-normal text-zinc-600">
          {{ __('Role') }}
        </th>
        <th class="px-8 py-4 font-medium leading-normal text-zinc-600">
          {{ __('Date') }}
        </th>
        <th
            v-if="isRoleCompanyOwner || isRoleHrManagement"
            class="px-8 py-4 font-medium leading-normal text-zinc-600"
        >
          {{ __('Action') }}
        </th>
      </tr>
      </thead>
      <tbody>
      <Member
          v-for="member in members"
          :key="member.id"
          :member="member"
          :options="options"
          :can-edit="isRoleCompanyOwner || isRoleHrManagement"
          :is-current-user="member.id === user.id"
          @update="handleUpdateButtonClick"
          @remove="handleRemoveButtonClick(member)"
      />

      </tbody>
    </table>

    <MemberDeleteModal
        v-if="isDeleteModalOpen"
        :member="selected"
        @cancel="handleCancelButtonClick"
        @continue="handleContinueButtonClick"
    />
  </div>
</template>

<style scoped>

</style>